export enum TransferType {
	IMMEDIATE = 'IMMEDIATE',
	SCHEDULED = 'SCHEDULED',
}

export interface CreateTransferDto {
	keepBenefits: boolean;
	scheduledDate?: string;
	toOrganizationId: string;
	transferType: TransferType;
}

export interface BeneficiaryTransferDto {
	id: string;
	beneficiaryId: string;
	cancelledAt?: string;
	createdAt: string;
	executedAt?: string;
	fromOrganizationId: string;
	keepBenefits: boolean;
	scheduledDate?: string;
	status: 'CANCELLED' | 'EXECUTED' | 'PENDING';
	toOrganization?: {
		id: string;
		name: string;
	};
	toOrganizationId: string;
	transferType: TransferType;
}
